<template>
  <div class="home">
    <div class="foo hero">
  
    <div class="x title greeting">
      <h1>Hello World!</h1>
      <h2>I'm Ted, a Full<code>-</code>Stack Developer</h2>
    </div>
    <div class="y tag">
      <p>It's all about: <code>$ ./build && make</code></p>
      </div>
      <div class="z call">
      <p>What can we develop <a href="#about"  style="font-size:72px;color: #e83e8d;text-decoration: underline;" >?</a></p>
      </div>
      

      </div>

   <div class="e splash">
   <svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 378.6 1590 378.1" enable-background="new 0 378.6 1590 378.1" xml:space="preserve" sodipodi:docname="blk.svg" inkscape:version="1.0.2 (e86c870879, 2021-01-15, custom)" class="logo"><metadata id="metadata189"><RDF><Work rdf:about=""><format>image/svg+xml</format><type rdf:resource="http://purl.org/dc/dcmitype/StillImage"></type><title></title></Work></RDF></metadata><defs id="defs187"></defs><defs><filter id="f2" x="0" y="0" width="400%" height="400%"><feOffset result="offOut" in="SourceAlpha" dx="20" dy="-5"></feOffset><feGaussianBlur result="blurOut" in="offOut" stdDeviation="10"></feGaussianBlur><feBlend in="SourceGraphic" in2="blurOut" mode="normal"></feBlend></filter></defs><g id="Слой_1"><g id="g181"><path filter="url(#f2)" fill="#000" stroke="#e83e8c" stroke-miterlimit="10" d="M1584.3,648.9l-1.7,6.1l-20.8,1.1l-3.4-3.8v-70.5    l-57.7-0.2c0.6,0,1.3-0.6,1.3-1.3c0-0.8-0.6-1.5-1.5-1.5s-1.5,0.6-1.5,1.5c0,0.6,0.6,1.3,1.3,1.3h-7.8c0.6-0.2,1.1-0.6,1.1-1.3    c0-0.8-0.6-1.5-1.5-1.5c-0.8,0-1.5,0.6-1.5,1.5c0,0.6,0.4,1.3,1.1,1.3h-2.1v15l-21.1,2.1v58.1l-3.4,2.7v-20l-4.8,0.2v-11.2h-19    V515.1l-1.1-0.2c0.4-0.4,0.6-0.8,0.6-1.5c0-1.3-1.1-2.1-2.1-2.1s-2.1,1.1-2.1,2.1c0,0.2,0,0.4,0.2,0.6l-66.5-13.5l-15-1.3    c0.2-0.4,0.4-0.6,0.4-1.3c0-1.3-1.1-2.1-2.1-2.1s-2.1,1.1-2.1,2.1c0,0.2,0,0.6,0.2,0.8l-1.7-0.2v16.8l-6.5,6.9v8.2l-9.3,2.9V651    l-15-1.9v-4.6h-11v4.6h-25.9v-155l-5.9-5.3h-0.2c0.2-0.2,0.4-0.6,0.4-1.1c0-0.8-0.6-1.5-1.5-1.5s-1.5,0.6-1.5,1.5    c0,0.4,0.2,0.6,0.2,0.8l-18.7-1.3v-25.5c0.8-0.2,1.3-1.1,1.3-1.9c0-1.1-0.8-1.9-1.9-1.9s-1.9,0.8-1.9,1.9c0,0.8,0.6,1.5,1.3,1.9    v25.5l-7.4,0.4l-15.2,0.4c0.2-0.2,0.4-0.6,0.4-1.1c0-0.8-0.6-1.5-1.5-1.5s-1.5,0.6-1.5,1.5c0,0.6,0.2,1.1,0.6,1.3h-0.4l-6.9,12.2    v17.9l-8.8-0.2v19.8l-6.5,1.3v65.3l-4.4-0.2l-5.3,2.9v7.4l-6.3,0.2v-9.5h-5.5v-97.1l-9.3-3.4l-11.8,0.2v14.3h-42.5v-13.1    l-21.7-0.4v73.1h-24.4V549l-13.1-3.8l-57.1,1.5v15.6H981v7.4h-12.2v-6.5l-59-1.3v9.1h-18.1v-3.2l-12.4-0.4v-83.8l-72.4-2.9    l-13.9-0.2l-13.9,4V553l-12.2-0.2h-8.8l-3.8,19.6l-3.4,0.6v17.9l-12.8-0.2V603h-9.7v8.8l-4.8-0.4V503.8l-17.5-0.6l-18.3-0.4V500    l-15.6,0.4l-6.3,4h-41.3l-9.9,3.2V533h-2.7l-3.8-4.4l-6.3,5.7l-2.5-0.4l-8,5.5h-15v-12.4h-7.6l-4.4-7.8h-38.1l-4.2,7.6h-8v54.8    h-18.1v5.7h-3.2v14.1h-5.3v7.6H481v7.6h-18.5v6.1h-17.3v-28l-8-0.2v-8.8h-23.6v-50.5h-9.3v3.2l-13.3-0.2v-6.5l-27.2-0.2v-31h-8    v-37.5l-24.6-8.8h-16v-9.3l0,0v-6.1l1.5-0.2v-2.9l-1.5-0.2v-5.9h1.1v-1.7h-1.1v-2.3c1.1-0.2,1.7-1.1,1.7-2.1    c0-1.1-0.8-1.9-1.7-2.1l-0.2-23.4h0.2c1.1,0,1.9-0.8,1.9-1.9s-0.8-1.9-1.9-1.9s-1.9,0.8-1.9,1.9c0,0.8,0.6,1.7,1.5,1.7l-1.1,23.4    c-0.8,0.4-1.5,1.1-1.5,2.1c0,0.8,0.4,1.7,1.3,1.9l-0.2,2.3h-0.8v1.7h0.8l-0.2,5.9h-1.5v3.4h1.5l-0.2,6.1h-24.6    c0.4-0.2,0.6-0.8,0.6-1.3c0-0.8-0.6-1.7-1.7-1.7s-1.7,0.6-1.7,1.7c0,0.4,0.2,0.8,0.6,1.3h-0.6v8.4h-25.3V584l-21.7-0.4v-10.7    l1.1-1.9v-8v-3.8h-2.9l-5.3-21.3l-3.2-0.2l-4.2,11.6l-5.9,0.4l0.2-45.1h-9.9v-10.5h-80.2v27.8H75.4v-3.2H57.7l-0.6,23.8L27,541.9    l0.2,27.6L13.9,569v77.3L0,641.3v115.2l1590,0.4V648.4L1584.3,648.9z" id="path175" class="logo" stroke-width="10"></path><path filter="url(#f2)" fill="#000" stroke="#e83e8c" stroke-miterlimit="10" d="M1584.3,648.9l-1.7,6.1l-20.8,1.1l-3.4-3.8v-70.5    l-57.7-0.2c0.6,0,1.3-0.6,1.3-1.3c0-0.8-0.6-1.5-1.5-1.5s-1.5,0.6-1.5,1.5c0,0.6,0.6,1.3,1.3,1.3h-7.8c0.6-0.2,1.1-0.6,1.1-1.3    c0-0.8-0.6-1.5-1.5-1.5c-0.8,0-1.5,0.6-1.5,1.5c0,0.6,0.4,1.3,1.1,1.3h-2.1v15l-21.1,2.1v58.1l-3.4,2.7v-20l-4.8,0.2v-11.2h-19    V515.1l-1.1-0.2c0.4-0.4,0.6-0.8,0.6-1.5c0-1.3-1.1-2.1-2.1-2.1s-2.1,1.1-2.1,2.1c0,0.2,0,0.4,0.2,0.6l-66.5-13.5l-15-1.3    c0.2-0.4,0.4-0.6,0.4-1.3c0-1.3-1.1-2.1-2.1-2.1s-2.1,1.1-2.1,2.1c0,0.2,0,0.6,0.2,0.8l-1.7-0.2v16.8l-6.5,6.9v8.2l-9.3,2.9V651    l-15-1.9v-4.6h-11v4.6h-25.9v-155l-5.9-5.3h-0.2c0.2-0.2,0.4-0.6,0.4-1.1c0-0.8-0.6-1.5-1.5-1.5s-1.5,0.6-1.5,1.5    c0,0.4,0.2,0.6,0.2,0.8l-18.7-1.3v-25.5c0.8-0.2,1.3-1.1,1.3-1.9c0-1.1-0.8-1.9-1.9-1.9s-1.9,0.8-1.9,1.9c0,0.8,0.6,1.5,1.3,1.9    v25.5l-7.4,0.4l-15.2,0.4c0.2-0.2,0.4-0.6,0.4-1.1c0-0.8-0.6-1.5-1.5-1.5s-1.5,0.6-1.5,1.5c0,0.6,0.2,1.1,0.6,1.3h-0.4l-6.9,12.2    v17.9l-8.8-0.2v19.8l-6.5,1.3v65.3l-4.4-0.2l-5.3,2.9v7.4l-6.3,0.2v-9.5h-5.5v-97.1l-9.3-3.4l-11.8,0.2v14.3h-42.5v-13.1    l-21.7-0.4v73.1h-24.4V549l-13.1-3.8l-57.1,1.5v15.6H981v7.4h-12.2v-6.5l-59-1.3v9.1h-18.1v-3.2l-12.4-0.4v-83.8l-72.4-2.9    l-13.9-0.2l-13.9,4V553l-12.2-0.2h-8.8l-3.8,19.6l-3.4,0.6v17.9l-12.8-0.2V603h-9.7v8.8l-4.8-0.4V503.8l-17.5-0.6l-18.3-0.4V500    l-15.6,0.4l-6.3,4h-41.3l-9.9,3.2V533h-2.7l-3.8-4.4l-6.3,5.7l-2.5-0.4l-8,5.5h-15v-12.4h-7.6l-4.4-7.8h-38.1l-4.2,7.6h-8v54.8    h-18.1v5.7h-3.2v14.1h-5.3v7.6H481v7.6h-18.5v6.1h-17.3v-28l-8-0.2v-8.8h-23.6v-50.5h-9.3v3.2l-13.3-0.2v-6.5l-27.2-0.2v-31h-8    v-37.5l-24.6-8.8h-16v-9.3l0,0v-6.1l1.5-0.2v-2.9l-1.5-0.2v-5.9h1.1v-1.7h-1.1v-2.3c1.1-0.2,1.7-1.1,1.7-2.1    c0-1.1-0.8-1.9-1.7-2.1l-0.2-23.4h0.2c1.1,0,1.9-0.8,1.9-1.9s-0.8-1.9-1.9-1.9s-1.9,0.8-1.9,1.9c0,0.8,0.6,1.7,1.5,1.7l-1.1,23.4    c-0.8,0.4-1.5,1.1-1.5,2.1c0,0.8,0.4,1.7,1.3,1.9l-0.2,2.3h-0.8v1.7h0.8l-0.2,5.9h-1.5v3.4h1.5l-0.2,6.1h-24.6    c0.4-0.2,0.6-0.8,0.6-1.3c0-0.8-0.6-1.7-1.7-1.7s-1.7,0.6-1.7,1.7c0,0.4,0.2,0.8,0.6,1.3h-0.6v8.4h-25.3V584l-21.7-0.4v-10.7    l1.1-1.9v-8v-3.8h-2.9l-5.3-21.3l-3.2-0.2l-4.2,11.6l-5.9,0.4l0.2-45.1h-9.9v-10.5h-80.2v27.8H75.4v-3.2H57.7l-0.6,23.8L27,541.9    l0.2,27.6L13.9,569v77.3L0,641.3v115.2l1590,0.4V648.4L1584.3,648.9z" id="path175" class="logo" stroke-width="0"></path></g></g></svg>

    </div>
  <div>
        <div class="parent">
      <div class="div1 module-border-wrap">
      <div class="module marker"> 
      <p>
      A specific tool for a specific job
      
      </p>
      </div>
      </div>
      <div id="about" class="div3"> 
      <p align="left">
      I execute projects that leverage multiple languages and frameworks to create intelligent online software tailored to the evolving demands on the moment.
      </p>
      </div>
 
      <div class="div4 marker module-border-wrap">
      <div class="module"  > 
      <p style="padding-top: 3px; margin-bottom: 0px;">
        Problems demand solutions. 
      </p>
      </div>
      </div>
      <div style="z-index:3;" class="div2"> 
      <p>
        Meeting these demand fuels me more than morning coffee.  
      </p>
      <p >Come take a <router-link style="text-decoration: underline;padding-bottom: 10px;color:#e83e8c" to="/skills">look</router-link>.</p>
      </div> 
     
 
      </div>

      </div>
  </div>
</template>
<style lang="scss">

.module-border-wrap {
  max-width: 550px;
  padding: 0rem;
  position: relative;
  background: linear-gradient(to right, #e83e8c, purple);
  padding: 8px;
  border-radius: 10px;
}

.module {
  background: #fff;
  color: #e83e8c;
  padding-bottom: 3px;

}
.marker {
  color:#e83e8c;
  font-family: 'Permanent Marker', cursive;
  padding-top: 10px;

}

.logo {
  fill:white;
  z-index: -1;
    
}
.foo {
  height: 100vh;
  display: grid; 
  grid-auto-rows: 1fr; 
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr; 
  grid-template-rows: 1fr 1fr 1fr 1fr 1fr; 
  gap: 5px 5px;
  padding-top: 50px; 
  grid-template-areas: 
    "x x . y y"
    ". . . . ."
    ". z z z ."
    ". . a . ."
    "e e e e e"; 
  justify-content: space-evenly; 
  align-content: stretch; 
  justify-items: stretch; 
  align-items: stretch; 
}
.x { grid-area: x;
padding-top: 30px; }
.y { grid-area: y; justify-self: start; padding-top: 80px; }
.z { grid-area: z; justify-self: center}
.a { grid-area: a;  }
.e { grid-area: e;  
margin-top: -325px;}

.parent {
    height: 600px;
    width: 100%;
    margin-bottom: 50px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 24px;
    display: grid;
    grid-template-columns: 1fr 2fr 1fr min-content auto; 
    grid-template-rows: 1fr 1fr 1fr 1fr min-content auto; 
    color: black;
    background-color: #fff;
    grid-template-areas: 
    "a a f"
    "b b b" 
    ". c c"
    "d d .";
}
.div1{
    grid-area: a;
    align-self: center; 
}
.div2{
    grid-area: d;
    padding-left: 10px;
    
    /* align-self: center;  */
}
.div3{
    grid-area: b;
    align-self: center;
    padding: 10px;
  
}
.div4{
    grid-area: c;
    align-self: center; 
}
.div5{
    background-color: red;
    grid-area: e;
}
.div6{
   
    grid-area: f;
}
.div7{
   
    grid-area: g;
}
.hero {
    background-image: url("https://res.cloudinary.com/duvzhauq9/image/upload/v1624735111/zoltan-tasi-jjv1OW1T2bI-unsplash_pfjrkf.jpg");
  
}
.home {
  width: 100vw;
 color: white;
}
.greeting h1 {
  font-size: 58px;
}
.tag p{
  font-size: 48px;
  margin-left: -175px;
}

.call {
  font-size: 42px;
}
@media only screen and (max-width: 1450px) { 
.title h1{
      padding-top: 75px;
      font-size: 48px;
      margin-bottom: 50px;
   
}
.tag{
    font-size: 24px;
    
   
}

.call {
    font-size: 26px;
    margin-top: 75px;
   
}
.foo {
  height: 100vh;
  display: grid; 
  grid-auto-rows: 1fr; 
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr; 
  grid-template-rows: 1fr 1fr 1fr 1fr 1fr; 
  gap: 5px 5px; 
  padding-top: 0px;
  grid-template-areas: 
    "x x x x ."
    ". . y y y"
    ". z z z ."
    ". . a . ."
    ". . . . ."; 
  justify-content: space-evenly; 
  align-content: stretch; 
  justify-items: stretch; 
  align-items: stretch; 
}
.z { grid-area: z; justify-self: center}

.e { grid-area: e;  
margin-top: -225px;}
}

@media only screen and (max-width: 850px) { 

.foo {
  height: 100vh;
  display: grid; 
  grid-auto-rows: 1fr; 
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr; 
  grid-template-rows: 1fr 1fr 1fr 1fr 1fr; 
  gap: 5px 5px; 
  grid-template-areas: 
    "x x x x ."
    ". . . y y"
    "z z z z z"
    ". . a . ."
    ". . . . ."; 
  justify-content: space-evenly; 
  align-content: stretch; 
  justify-items: stretch; 
  align-items: stretch; 
}

.greeting h1 {
  font-size: 48px;
}
.tag p{
  font-size: 20px;
  margin-left: -175px;
}
.call {
  font-size: 20px;;
}
.z { grid-area: z; justify-self: center}

}


@media only screen and (max-width: 650px) { 
.e { grid-area: e;  
margin-top: -80px;}
.parent {
  font-size: 18px;
}
.div2{
    grid-area: d;
    padding-left: -12px;
    margin-left: 80px;
    margin-right: -80px;
    /* align-self: center;  */
}
}

.glow-on-hover {
    width: 220px;
    height: 50px;
    border: none;
    outline: none;
    color: #fff;
    background: #fff;
    cursor: pointer;
    position: relative;
    z-index: 0;
    border-radius: 10px;
}

.glow-on-hover:before {
    content: '';
    background: linear-gradient(45deg, #ff0000, #0011ff, #1d3cc8, #ff00c8, #e83e8c, rgb(187, 73, 102), #7a00ff, #ff00c8, #ff0000);
    position: absolute;
    top: -2px;
    left:-2px;
    background-size: 400%;
    z-index: -1;
    filter: blur(5px);
    width: calc(100% + 4px);
    height: calc(100% + 4px);
    animation: glowing 20s linear infinite;
    opacity: 0;
    transition: opacity .3s ease-in-out;
    border-radius: 15px;
}

.glow-on-hover:active {
    color: black;
}

.glow-on-hover:active:after {
    background: transparent;
}

.glow-on-hover:hover:before {
    opacity: 1;
}

.glow-on-hover:after {
    z-index: -1;
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(253, 0, 198, 0.281);
    left: 0;
    top: 0;
    border-radius: 10px;
}

@keyframes glowing {
    0% { background-position: 1 0; }
    50% { background-position: 100% 0; }
    100% { background-position: 0 0; }
}
.arrow {
  box-sizing: border-box;
  margin-left: 150px;
  height: 50px;
  width: 50px;
  border-style: solid;
  border-color: black;
  border-width: 0px 12px 12px 0px;
  transform: rotate(45deg);
  transition: border-width 150ms ease-in-out;
}

.arrow:hover {
  border-bottom-width: 4px;
  border-right-width: 4px;
}




</style>

<script>
// @ is an alias to /src
export default {
  name: 'Home',

}
</script>